module.exports = __webpack_public_path__ + "static/media/visa_mc_logo.f1156a80.png";